import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    vouchersToPrint: []
}

const voucherSlice = createSlice({
    name: "addstaff",
    initialState,
    reducers: {
        addVoucherToPrint: (state, action) => {
            state.vouchersToPrint = [];
            state.vouchersToPrint[0] = action.payload;
        },
        addMultiVoucherToPrint: (state, action) => {
            state.vouchersToPrint = [];
            state.vouchersToPrint = action.payload;
        }
    }
});

export const { addVoucherToPrint, addMultiVoucherToPrint } = voucherSlice.actions;
export default voucherSlice.reducer;